import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import * as go from "gojs";

import {
  DataSyncService,
  DiagramComponent,
  PaletteComponent,
} from "gojs-angular";
import { CommonFunctionService } from "dhwani-material-library";
import { Router } from "@angular/router";
import { NgxCaptureService } from 'ngx-capture';
import { tap } from "rxjs/operators";
import { defer, from } from "rxjs";



@Component({
  selector: "app-form-linking",
  templateUrl: "./form-linking.component.html",
  styleUrls: ["./form-linking.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class FormLinkingComponent implements OnInit, AfterViewInit {
  @ViewChild("myDiagram", { static: true })
  public myDiagramComponent: DiagramComponent;
  @ViewChild("myPalette", { static: true })
  public myPaletteComponent: PaletteComponent;
  public state = {
    diagramNodeData: [ ],
    diagramLinkData: [],
    skipsDiagramUpdate: false,
    selectedNodeData: null,
  };
  public diagramDivClassName: string = "myDiagramDiv";
  public paletteDivClassName = "myPaletteDiv";
  public oDivClassName = "myOverviewDiv";
  public observedDiagram = null;
  // currently selected node; for inspector
  public selectedNodeData: go.ObjectData = null;
  currentForm: any;
  @ViewChild('screen', { static: true }) screen: any;
  project_name: any ='';
  constructor(
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<FormLinkingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public commonFunction:CommonFunctionService,
    public router:Router,
    private ngxCaptureService: NgxCaptureService

  ) {
    let childLinkedForms = [];
    let childLinking = []
    let letters = '0123456789ABCDEF';
   
    for(let element of this.data.data){
      element['text'] = element['language'][0]['title']
      element['color']= "transparent";
      if(data.isForm && data.formId == element.formId ){
        element['color']= "#3867ff";
      }
      if(element.createDynamicOption && element.createDynamicOption.length){
        childLinkedForms.push(element.formId);
        childLinking.push(...element.createDynamicOption.map(ele => {
          childLinkedForms.push(ele.formId);
          return {'from':element.formId, "to":ele.formId}
        }));
      }
    }
    let notLinkedFormList = this.data.data.filter(f=> !([...childLinkedForms].indexOf(f.formId)> -1) )
    let linkedFormList = this.data.data.filter(f=>  (childLinkedForms.indexOf(f.formId)> -1) )
    this.state.diagramNodeData = [...linkedFormList, ...notLinkedFormList],
    this.state.diagramLinkData = childLinking;
  }
  ngOnInit() {
    this.project_name =  this.data.projectDetails['name'];
  }
  nodeClicked(){
    console.log("evt",this.currentForm);
    let project = this.data.projectDetails;
    this.project_name =  this.data.projectDetails['name'];
    sessionStorage.setItem('dateFilterConfig', project.filterConfig ? JSON.stringify(project.filterConfig) : '{"dateFilter":{"fromDate":true,"toDate":true,"dateType":"date"}}');
        sessionStorage.setItem('projectId', project._id);
        let flag = this.commonFunction.getWebUserDetails(project._id);
        sessionStorage.setItem('flag', flag.toString());
        sessionStorage.setItem('project_name', project.name);
        sessionStorage.setItem('selectedProject', JSON.stringify(project));
        // this.surveyForms = cardResponse.data;
            let allFormTitle = this.data.data.flatMap(item => [{ "formId": item.formId, "title": item.language[0].title, "_id": item._id, "publishedFormId": item.publishedFormId }]);
            sessionStorage.setItem('allFormTitle', JSON.stringify(allFormTitle));
        this.router.navigate(['/manage-form/build-survey',this.currentForm._id]).then(()=>this.dialogRef.close())
      //   [routerLink]="[
      //     '/manage-form/build-survey',
      //     form._id
      // ]
  }
  public ngAfterViewInit() {
    if (this.observedDiagram) return;
    this.observedDiagram = this.myDiagramComponent.diagram;
    this.cdr.detectChanges(); // IMPORTANT: without this, Angular will throw ExpressionChangedAfterItHasBeenCheckedError (dev mode only)

  } // end ngAfterViewInit

  public initDiagram = (): go.Diagram => {
    const $ = go.GraphObject.make;
    const dia = $(go.Diagram, {
      "undoManager.isEnabled": true,
      // "clickCreatingTool.archetypeNodeData": {
      //   text: "new node",
      //   color: "lightblue",
      // },
      model: $(go.GraphLinksModel, {
        nodeKeyProperty: "formId",
        // linkToPortIdProperty: "toPort",
        // linkFromPortIdProperty: "fromPort",
        linkKeyProperty: "formId", // IMPORTANT! must be defined for merges and data sync when using GraphLinksModel
      }),
    });

    dia.commandHandler.archetypeGroupData = { key: "Group", isGroup: true };

    const makePort = function (id: string, spot: go.Spot) {
      return $(go.Shape, "Circle", {
        opacity: 0.5,
        fill: "#d3d3d3",
        strokeWidth: 0,
        desiredSize: new go.Size(4, 4),
        portId: id,
        alignment: spot,
        fromLinkable: false,
        toLinkable: false,
      });
    };
    // define the Node template
    dia.nodeTemplate = $(
    
      go.Node, "Auto",
      {
        click: async (e, node: go.Node) => { 
        
          this.currentForm = await node.data;
          // console.log("this.currentForm[after]",this.currentForm)
          // this.nodeClicked(e,node.data)
          // this.getInfo(node.data)
           // highlight all Links and Nodes coming out of a given Node
           let diagram = node.diagram;
           console.log("check obj",node);
           
           diagram.startTransaction("highlight");
           // remove any previous highlighting
           diagram.clearHighlighteds();
           node.findLinksOutOf().each(function(l) { 
            l.isHighlighted = true; });
           node.findNodesOutOf().each(function(n) { 
            n.isHighlighted = true; });
           diagram.commitTransaction("highlight");
        }
      },
    $(go.Shape, "RoundedRectangle",
    { width: 140, height: 50, fill: null },
      // new go.Binding("fill", "yellow"),
      // the Shape.stroke color depends on whether Node.isHighlighted is true
      new go.Binding("fill", "isHighlighted", function(h) { return h ? "#3867ff" : "grey"; }).ofObject(),
      new go.Binding("fill", "isSelected", function(h) { return h ? "#3E8BEB" : "grey"; }).ofObject()),
      "Spot",
      {
        contextMenu: $(
          "ContextMenu",
          $(
            "ContextMenuButton",
            $(go.TextBlock, "Group"),
            {
              click: function (e, obj) {
                e.diagram.commandHandler.groupSelection();
              },
            },
            new go.Binding("visible", "", function (o) {
              return o.diagram.selection.count > 1;
            }).ofObject()
          )
        ),
      },
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(
        go.Point.stringify
      ),
      $(
        go.Panel,
        "Auto",
        $(
          go.Shape,
          "RoundedRectangle",
          { width: 140, height: 50, fill: null },
          new go.Binding("fill", "color", (c, panel) => {
            return c;
          })
        ),
        $(
          go.TextBlock,
          { margin: 8, editable: true },
          new go.Binding("text").makeTwoWay()
        )
      ),
      {
        toolTip:  // define a tooltip for each node that displays the color as text
          $(go.Adornment, "Auto",
            $(go.Shape, { fill: "#FFFFCC" }),
            $(go.TextBlock, { margin: 4 },
              
              new go.Binding("text", "", diagramInfo ))
              // new go.Binding("text", "text" ))
          )  // end of Adornment
      },
      // Ports
      makePort("t", go.Spot.TopCenter),
      makePort("l", go.Spot.Left),
      makePort("r", go.Spot.Right),
      makePort("b", go.Spot.BottomCenter),
      makePort("T", go.Spot.Top),
      makePort("L", go.Spot.Left),
      makePort("R", go.Spot.Right),
      makePort("B", go.Spot.Bottom)
    )
    function diagramInfo(model) {

      return  "Form Id:-" + model.formId  + `\n` +
              "Form Name:-"+ model.text + `\n` +
              "Published Form Id:-"+model.publishedFormId+
              "Parent:-"+model.getDynamicOption.length+ `\n` +
              "Child:-"+model.createDynamicOption.length+ `\n`
    }
    return dia;
  }
  closeDialog(){
    this.dialogRef.close()
  }
  snapShot() {
    return defer(() => from( this.ngxCaptureService.getImage(this.screen.nativeElement, true))
    .pipe(
      tap(img => {
        console.log(img);
        let a = document.createElement("a"); //Create <a>
        a.href =img; //Image Base64 Goes here
        // a.download = this.project_name +".png"; //File name Here
        a.download = `${this.project_name}.png`; //File name Here
        a.click(); //Downloaded file
      })
    )).subscribe();
   
}
}
